import { CREATETASK, GETTASK, DELETETASK, UPDATETASK } from "../actions/types";

const initialState = {};

// eslint-disable-next-line import/no-anonymous-default-export
export default function (state = initialState, action) {
  switch (action.type) {
    case GETTASK:
      return {
        ...state,
        taskList: action.payload.data,
      };
    case UPDATETASK:
      return {
        ...state,
        taskUpdateStatus: action.payload.success,
      };

    case DELETETASK:
      return {
        ...state,
        taskDeleteStatus: action.payload.success,
      };

    default:
      return state;
  }
}
